/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Credentials_SuccessInputs */



/**
* | output |
* | --- |
* | "Saved. The next sync uses the new values." |
*
* @param {Spaces_Credentials_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_credentials_success = /** @type {((inputs?: Spaces_Credentials_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Credentials_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeichert. Die nächste Synchronisation verwendet die neuen Werte.")
	return /** @type {LocalizedString} */ ("Saved. The next sync uses the new values.")
});